import { Component, inject } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FooterToolbarSaveButtonComponent } from "./footer-toolbar-save-button/footer-toolbar-save-button.component";
import { FooterToolbarService } from "./footer-toolbar.service";

@Component({
    selector: 'app-footer-toolbar',
    imports: [FontAwesomeModule, FooterToolbarSaveButtonComponent],
    templateUrl: './footer-toolbar.component.html',
    styleUrl: './footer-toolbar.component.scss',
})
export class FooterToolbarComponent {

    footerToolbarService = inject(FooterToolbarService);

}
